// src/components/nodes/OrgChartNode.js
import { NodeBase } from './NodeBase';

export class OrgChartNode extends NodeBase {
  constructor() {
    super('org', { 
      name: '张三',
      title: '项目经理',
      department: '技术部',
      avatar: null
    });
  }

  renderContent(data, selected) {
    const avatarSrc = data.avatar || '/images/avatars/default.png';
    
    return (
      <div className="org-content">
        <div className="org-avatar">
          <img 
            src={avatarSrc} 
            alt={data.name || '头像'} 
            className="org-avatar-img"
            onError={(e) => {
              // 图片加载失败时使用默认头像
              console.warn(`图片加载失败: ${avatarSrc}, 使用默认头像`);
              e.target.src = '/images/avatars/default.png';
            }}
            onLoad={(e) => {
              // 图片加载成功日志
              console.log(`图片加载成功: ${avatarSrc}`);
            }}
          />
        </div>
        <div className="org-info">
          <div className="org-name">
            {data.name || '姓名'}
          </div>
          <div className="org-title">
            {data.title || '职位'}
          </div>
          <div className="org-department">
            {data.department || '部门'}
          </div>
          {/* 调试信息 - 仅在开发环境显示 }
          { process.env.NODE_ENV === 'development' && data.avatarRepoPath && (
            <div className="debug-path" style={{fontSize: '10px', color: '#666', marginTop: '5px'}}>
              路径: {data.avatarRepoPath}
            </div>
          )*/}
        </div>
      </div>
    );
  }

  getConfig() {
    return {
      type: this.type,
      label: '组织节点',
      icon: '👤',
      defaultData: this.defaultData
    };
  }
}